export enum LanguageCode {
  en = 'en',
  ru = 'ru',
}

export const DEFAULT_LANGUAGE: string = LanguageCode.ru;
